<template>
  <div class="pop-up-menu">
    <slot name="pop-up-label"></slot>
    <i
      aria-hidden="true"
      class="fas fa-chevron-down pop-up-menu__icon"
    />
    <div
      class="pop-up-menu__pop-container"
      :class="{ 'pop-up-menu__no-padding': noPadding }"
    >
      <slot name="pop-up-body"></slot>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    noPadding: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"
@import "src/styles/defaults/mixins"
@import "src/styles/components/global-z-Index"

.pop-up-menu
  position: relative
  display: flex
  justify-content: center
  align-items: center
  &__icon
    margin-left: 5px
    font-size: 1.1em
  &__pop-container
    position: absolute
    top: 100%
    opacity: 0
    pointer-events: none
    transition: opacity .3s ease
    padding: 10px 15px
    background-color: var(--color-popupmenu-background)
    color: var(--font-color-primary)
    z-index: $z-index-popup-menu
    +md-box-shadow-2
    &__no-padding
      padding: 0
  &:hover
    .pop-up-menu
      &__pop-container
        opacity: 1
        pointer-events: all
  +media-min-sm()
  +media-min-md()
  +media-min-lg()
</style>

